import "core-js/modules/es.number.constructor.js";
import { mapState } from 'vuex';
export default {
  i18n: require('../../design_i18n'),
  props: {
    value: {
      type: Number,
      default: 0
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /**
     * 最大值
     */
    max: {
      type: Number,
      default: 500
    },
    /**
     * 最小值
     */
    min: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      height: 0,
      isDisabled: true,
      result: this.value
    };
  },
  watch: {
    value: function value(val) {
      this.result = val;
    }
  },
  created: function created() {
    this.height = this.value;
  },
  computed: {
    curValue: function curValue() {
      return this.value;
    },
    curHeight: {
      get: function get() {
        // if ( this.curValue == -1 ){
        //   this.isShowCustom = true
        // }
        return this.value;
      },
      set: function set(val) {
        if (val != -1) {
          this.isShowCustom = false;
        }
        this.value = val;
      }
    }
  },
  methods: {
    handleSearch: function handleSearch(val) {
      this.handleSelectChange(val);
    },
    setValue: function setValue(val) {
      val = val === '' ? 0 : parseInt(val);
      this.result = val;
      if (val > this.max) {
        this.result = this.max;
      }
      if (val < this.min) {
        this.result = this.min;
      }
      this.$emit('input', this.result);
    },
    handleSelectChange: function handleSelectChange(val) {
      // let value = (val != null & val != '') ? val   : 0
      // this.result = value
      // let num = parseInt(value)
      // if(num > 500) {
      //   this.$emit('input', 500)
      //   return
      // }
      // this.$emit('input', num)
      this.setValue(val);
    },
    handleBlur: function handleBlur(val) {
      //   this.result = val
      //   let num = parseInt(val)
      //   if(num > 500) {
      //     this.$emit('input', 500)
      //     return
      //   }
      // this.$emit('input', num)
      /* this.$emit('input', parseInt(val)) */

      this.setValue(val);
    },
    handleInputChange: function handleInputChange(e) {
      this.$emit('input', parseInt(e.target.value));
    },
    handleChange: function handleChange(e) {
      if (e == -1) {
        this.isDisabled = false;
        return;
      } else {
        this.isDisabled = true;
      }
      this.height = e;
      this.$emit('input', e);
    }
  }
};